import React from 'react'
import { connect } from 'react-redux'
import { RichText } from 'prismic-reactjs'
import Rellax from 'rellax'
import LazyLoad from 'react-lazyload'
import isEqual from 'lodash/isEqual'
import styles from './item.module.scss'
import Button from '../../Button'
import Icon from '../../Icon'
import Modal from '../../Modal'
import {
  calcParallax,
  elementVisible,
  makeContentRenderable,
} from '../../helper'

class ItemContainer extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      toggleInfo: false,
      scrollPosition: props.scrollPosition,
    }
    this.toggleInfo = this.toggleInfo.bind(this)
    this.initRellax = this.initRellax.bind(this)
  }

  static getDerivedStateFromProps(props, state) {
    if (!isEqual(props.scrollPosition, state.scrollPosition)) {
      return {
        scrollPosition: props.scrollPosition,
      }
    }
    return null
  }

  componentWillUnmount() {
    if (this.rellax) {
      this.rellax.destroy()
    }
  }

  componentDidMount() {
    this.props.onElementLoad()
  }

  initRellax() {
    if (this.elm && !this.rellax && this.props.wrapper !== null) {
      const config = {
        speed: this.props.speed,
        wrapper: this.props.wrapper,
        relativeToWrapper: true,
      }
      this.rellax = new Rellax(this.elm, config)
    }
  }

  toggleInfo() {
    this.setState(prevState => ({
      toggleInfo: !prevState.toggleInfo,
    }))
  }

  render() {
    const {
      width,
      height,
      x_axis,
      y_axis,
      content,
      layer,
      rotation,
      background,
      information,
      widthRatio,
      heightRatio,
    } = this.props
    const style = {
      left: `${x_axis}%`,
      top: `${y_axis}%`,
      zIndex: `${layer === null ? 1 : layer}`,
      width: `${width * widthRatio}px`,
    }
    const innerStyle = {
      transform: `translateX(0) rotateZ(${rotation}deg)`,
    }
    const itemCssClass = [styles.c]
    const cssClass = [styles.i, styles.pItem]
    const infoModalClass = [styles.infoModal]
    switch (background) {
      case 'White':
        cssClass.push(styles.w)
        break
      case 'Black':
        cssClass.push(styles.b)
        break
      case 'Shadow':
        cssClass.push(styles.s)
        break
    }
    if (
      (content.length === 1 && content[0].type === 'image') ||
      (content.length === 1 && content[0].type === 'embed')
    ) {
      cssClass.push(styles.img)
      style.height = `${height * widthRatio}px`
    } else {
      itemCssClass.push(styles.full)
    }
    if (this.state.toggleInfo) {
      infoModalClass.push(styles.showModal)
    }
    let renderableContent = makeContentRenderable(content)
    let renderableInfo = makeContentRenderable(information)
    return [
      <article
        style={style}
        className={itemCssClass.join(' ')}
        key="parallax_item"
      >
        <div
          style={innerStyle}
          className={cssClass.join(' ')}
          ref={elm => (this.elm = elm)}
        >
          {RichText.render(renderableContent)}
          {renderableInfo.length > 0 && (
            <Button onClick={this.toggleInfo} className={styles.infoBtn}>
              <Icon icon="info" small />
            </Button>
          )}
        </div>
      </article>,
      renderableInfo.length > 0 && (
        <Modal
          show={this.state.toggleInfo}
          onCancel={this.toggleInfo}
          key="info_modal"
        >
          <div className={infoModalClass.join(' ')}>
            {RichText.render(renderableInfo)}
          </div>
        </Modal>
      ),
    ]
  }

  componentDidUpdate(prevProps, prevState) {
    if (!isEqual(prevProps.wrapper, this.props.wrapper)) {
      this.initRellax()
    }
  }
}

const mapStateToProps = state => {
  return {
    scrollPosition: state.ui.scrollPosition,
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

const Item = connect(mapStateToProps, mapDispatchToProps)(ItemContainer)

Item.defaultProps = {}

Item.propTypes = {}

export default Item

export const iQuery = graphql`
  fragment Items on CaseJson {
    data {
      body {
        items {
          animation {
            link_type
          }
          content {
            type
            text
            spans {
              start
              end
              type
              data {
                link_type
                name
                kind
                url
                size
              }
            }
            url
            dimensions {
              width
              height
            }
            oembed {
              type
              embed_url
              title
              provider_name
              thumbnail_url
              height
              width
              version
              author_name
              author_url
              provider_url
              thumbnail_width
              thumbnail_height
              html
            }
          }
          information {
            type
            text
            spans {
              start
              end
              type
              data {
                link_type
                url
                target
              }
            }
          }
          x_axis
          y_axis
          layer
          rotation
          background
          width
          height
          speed
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/Section/Item/index.jsx